import {
  UPDATE_GAMESTATE,
  UPDATE_HANDLING_ROUND_STATE_CHANGE,
  FORCE_LANGUAGE,
} from './types';
import actions from './index';
import apiCall from '../components/apiCall';

/**
 *
 * @return {Function}
 */
const updateGameState = gameState => dispatch => {
  dispatch({ type: UPDATE_GAMESTATE, payload: gameState });
};

const setRoundState = (state, gameId, gameScores = null) => (dispatch) => {
  dispatch({ type: UPDATE_HANDLING_ROUND_STATE_CHANGE, payload: true });
  return apiCall(`/gameState/${state}${gameId ? `/${gameId}` : ''}`)
    .then((result) => {
      if (gameScores) {
        dispatch(submitGameScores(gameScores, gameId));
        return;
      }
      dispatch(actions.project.refreshProject());
    });
};

const deactivateGame = () => (dispatch, getState) => {
  return apiCall('/gameState/deactivate')
    .then((result) => {
      dispatch(actions.project.refreshProject());
    });
};

const submitGameScores = (gameScores, gameId, toggleSubmittingScores) => (dispatch, getState) => {
  apiCall(`/gameState/submitGameScores/${gameId}`, gameScores, 'POST')
    .then((result) => {
      if (toggleSubmittingScores) {
        toggleSubmittingScores(false);
      }
      dispatch(actions.project.refreshProject());
    });
};

const forceUpdateLanguage = (lang) => (dispatch) => {
  dispatch({ type: FORCE_LANGUAGE, payload: lang });
};

export default {
  updateGameState,
  deactivateGame,
  setRoundState,
  submitGameScores,
  forceUpdateLanguage,
};



// WEBPACK FOOTER //
// ./src/actions/gameState.js